/**
 * defined ctxDropdownListItem types are:
 *
 * DROPDOWN-HEADER exp: {type: 'dropdown-header', text: 'Some text...'},
 * DIVIDER exp: {type: 'divider'},
 * VALUE-FIELD exp: {type: 'value-field', text: '10 Rows', value: 10},
 * DROPDOWN-HEADER exp: {type: 'link', text: 'www.google.com', link: 'http://localhost:8080'},
 */

class CtxDropdownListItemController {
    constructor($scope, $element, $timeout) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.$scope.$watch(() => this.item.isSelected, (isSelected) => {
            this.$element[isSelected ? 'addClass' : 'removeClass']('selected');
        })
    }
}

CtxDropdownListItemController.$inject = ['$scope', '$element', '$timeout'];

class ctxDropdownListItem {
    constructor($timeout) {
        this.restrict = 'E';
        this.replace = true;
        this.template = '<li id="{{itemCtrl.item.id}}-page-size-{{itemCtrl.item.text.toLowerCase()}}" class="ctx-dropdown-item"></li>';
        this.controller = CtxDropdownListItemController;
        this.controllerAs = 'itemCtrl';
        this.require = '^ctxDropdownList';
        this.bindToController = {
            item: '='
        };

        this.$timeout = $timeout;
    }

    link(scope, element, attrs, ctxDropdownListCtrl) {
        let itemCtrl = scope.itemCtrl;
        switch(itemCtrl.item.type){
            case 'dropdown-header':
                element.attr('class', 'dropdown-header');
                element.text(itemCtrl.item.text);
                break;
            case 'value-field':
                element.html(`<a href="javascript: void(0)">${itemCtrl.item.text}</a>`);
                element.bind('click', () => {
                    ctxDropdownListCtrl.setValue(itemCtrl.item);
                    element.addClass('selected');
                });
                break;
            case 'divider':
                element.attr('role', 'separator');
                element.attr('class', 'divider');
                break;
            case 'link':
                element.html(`<a href="${itemCtrl.item.link}" target="_blank">${itemCtrl.item.text}</a>`);
                break;
            default:
                break;
        }
    }

    static directiveFactory($timeout) {
        return new ctxDropdownListItem($timeout);
    }
}

ctxDropdownListItem.directiveFactory.$inject = ['$timeout'];

module.exports = ctxDropdownListItem.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxDropdown/ctxDropdownListItem.directive.js